import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import dashboardSaga from "./dashboard/saga"
import conceptSaga from "./config/concept/saga"
import typeSaga from "./config/type/saga"
import areasSaga from "./areas/areaUser/saga"
import monitorSaga from "./monitor/order/saga"
import monitorSupplierSaga from "./monitor/supplier/saga"
import monitorTypeSaga from "./monitor/type/saga"
import monitorOrderCountSaga from "./monitor/orderCount/saga"
import userSaga from "./users/homeUsers/saga"
import suppliers from "./supplier/saga"
import societySaga from "./society/saga"
import messageSaga from "./dashboard/message/saga"
import paymentDetail from "./paymentDetail/saga"
import banksSaga from "./banks/saga"
import fileRequirement from "./filesrequirement/saga"
import fileUpload from "./fileUpload/saga"
import materialSupplierSaga from "./materialSupplier/saga"
import notificationsEmail from "./notificationsEmail/saga"
export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(conceptSaga),
    fork(typeSaga),
    fork(areasSaga),
    fork(monitorSaga),
    fork(monitorSupplierSaga),
    fork(monitorTypeSaga),
    fork(userSaga),
    fork(suppliers),
    fork(societySaga),
    fork(monitorOrderCountSaga),
    fork(messageSaga),
    fork(banksSaga),
    fork(paymentDetail),
    fork(fileRequirement),
    fork(fileUpload),
    fork(materialSupplierSaga),
    fork(notificationsEmail)
  ])
}
